'use client';

import iconMenuList from '@/assets/images/icons/icon-menu-list.png';
import iconMenuTile from '@/assets/images/icons/icon-menu-tile.png';
import PageHeader from '@/components/layouts/PageHeader/PageHeader';
import ProductFirstSelectTitle from '@/components/ui/ProductFirstSelectTitle/ProductFirstSelectTitle';
import SectionTitle from '@/components/ui/SectionTitle/SectionTitle';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { sendWorksViewModeSwitchEvent } from '@/utils/ga';
import { useSession } from 'next-auth/react';
import { useState } from 'react';
import { ViewMode, type ViewModeType } from '../../types';
import styles from './WorksPageHeader.module.scss';

function WorksPageHeader({
  workCount,
  currentViewMode,
  onViewModeChange,
  selectedProductId,
  titleProductImagePath,
}: {
  workCount: number;
  currentViewMode: ViewModeType;
  onViewModeChange: (mode: ViewModeType) => void;
  selectedProductId?: number;
  titleProductImagePath?: string;
}) {
  const [isViewModeChanging, setIsViewModeChanging] = useState(false);
  const session = useSession();

  const handleToggleButtonClick = () => {
    //TODO:描画が切り替わった後にChangingフラグを落とすようにする
    if (isViewModeChanging) return;
    setIsViewModeChanging(true);
    const nextMode = currentViewMode === ViewMode.tile.value ? ViewMode.list.value : ViewMode.tile.value;
    onViewModeChange(nextMode);
    setIsViewModeChanging(false);

    // GAイベント送信
    const userId = session?.data?.user.id ?? 0;
    sendWorksViewModeSwitchEvent(nextMode, userId);
  };

  const getButtonContainerClassName = () => {
    return `${styles.worksListButtonContainer} ${selectedProductId ? styles.worksListButtonContainerWithProduct : ''}`;
  };

  return (
    <div className={styles.worksPageHeaderContainer}>
      <div className={styles.worksTitleContainer}>
        {selectedProductId ? (
          <ProductFirstSelectTitle productImage={titleProductImagePath || ''} title='作品を選ぶ' />
        ) : (
          <>
            <div className={utilsStyles.onlyPc}>
              <SectionTitle englishLabel='LINEUP' japaneseLabel='作品一覧' />
              <div className={styles.worksTitleSubContainer}>
                <p className={styles.worksTitleSubText}>
                  好きな<span className={styles.accentText}>作品</span>を選ぼう
                </p>
                <p className={styles.worksCountContainer}>
                  <span className={styles.worksCount}>{workCount}</span>
                  <span className={styles.worksCountLabel}>作品</span>
                </p>
              </div>
            </div>
            <div className={utilsStyles.onlySp}>
              <PageHeader text='好きな作品を選ぼう' textBold sideCount={workCount} sideText='作品' size='xSmall' />
            </div>
          </>
        )}
      </div>
      <div className={getButtonContainerClassName()}>
        <div className={styles.toggleButtonContainer}>
          <button
            type='button'
            onClick={handleToggleButtonClick}
            className={styles.toggleButton}
            data-testid={currentViewMode === ViewMode.tile.value ? 'switch-to-list-button' : 'switch-to-tile-button'}
          >
            <span>{ViewMode[currentViewMode].text}</span>
            <img
              src={currentViewMode === ViewMode.list.value ? iconMenuTile.src : iconMenuList.src}
              className={styles.toggleButtonIcon}
              alt={ViewMode[currentViewMode].text}
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default WorksPageHeader;
